import { Injectable } from '@angular/core';
import { IPayerType } from 'src/app/models/IPayerType';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { configuration } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PayerTypeService {

  constructor(private http: HttpClient) { }

  // Get all payer type details
  getAllPayerType(): Observable<IPayerType[]> {
    return this.http.get<IPayerType[]>(`${configuration.apiUrl + 'Master/PayerType'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  // Add payer type details
  addPayerTypeDetails(payerTypeDetails: IPayerType): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/PayerType'}`, payerTypeDetails, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Update payer type details
  updatePayerTypeDetails(payerTypeDetails: IPayerType): Observable<string> {
    return this.http.put<string>(`${configuration.apiUrl + 'Master/PayerType'}`, payerTypeDetails, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
